import * as React from "react";
import { Field } from "formik";
import FilterSelect from "views/components/widgets/overview-configuration/filters/FilterSelect";
import SelectedFiltersList from "./SelectedFiltersList";
const FiltersConfiguration = ({ filterComponents, columnTitle, name }) => /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Field, { name }, ({ field: { value: values, onChange } }) => {
  const changeField = (filtersValue) => onChange({ target: { value: filtersValue, name } });
  const onCreate = (column, value) => {
    const filterList = values.toList();
    const filterIndex = values.toList().findIndex(({ field }) => field === column);
    if (filterIndex >= 0) {
      const existingColumnFilter = filterList.get(filterIndex);
      const newColumnFilter = { ...existingColumnFilter };
      if (!newColumnFilter.value.includes(value)) {
        newColumnFilter.value = [...newColumnFilter.value, value];
        return changeField(filterList.set(filterIndex, newColumnFilter).toOrderedSet());
      }
    }
    return changeField(filterList.push({ field: column, value: [value] }).toOrderedSet());
  };
  const onDelete = (filterIndex, value) => {
    const filterList = values.toList();
    const filter = filterList.get(filterIndex);
    if (filter.value.length === 1) {
      return changeField(filterList.delete(filterIndex).toOrderedSet());
    }
    const newFilter = { ...filter, value: filter.value.filter((val) => val !== value) };
    return changeField(filterList.set(filterIndex, newFilter).toOrderedSet());
  };
  const onEdit = (filterIndex, valueIndex, newValue) => {
    const filterList = values.toList();
    const filter = { ...filterList.get(filterIndex) };
    const newFilterValue = [...filter.value];
    newFilterValue[valueIndex] = newValue;
    filter.value = newFilterValue;
    changeField(filterList.set(filterIndex, filter).toOrderedSet());
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    SelectedFiltersList,
    {
      selectedFilters: values,
      columnTitle,
      onDelete,
      onEdit,
      filterComponents
    }
  ), /* @__PURE__ */ React.createElement(
    FilterSelect,
    {
      selectedFilters: values,
      filterComponents,
      columnTitle,
      onCreate
    }
  ));
}));
export default FiltersConfiguration;
